import { DisabledPrompt, Link, useStateManager } from "@bcm-dev/bcms-vite";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function MobileACHParticipantsTable
 * @returns {React.Component}
 * @exported true
 * @description The mobile table for the ParticipantsACHPage.
 */
export default function MobileACHParticipantsTable(props) {
  const { data, ui, onSelectAllCheckmarksChange } = useStateManager();
  const allRowsAreChecked = data.participants.every(participant => participant.isChecked === true);
  
  const mobileParticipants = data.participants.reduce((acc, participant, index) => {
    // Time is hardcoded for now
    const minutes = index % 2 === 0 ? 0 : 30;
    participant.createdDate.time = [8, minutes, 0];
    acc.push(<MobileACHParticipantsTableRow key={ participant.id } participant={ participant } />);
    return acc;
  }, []);

  return (
    <div className="mobile-ach-participants-table flex-container flex-vertical">
      <div className="flex-height table-header">
        <UICheckbox value={ allRowsAreChecked ? "checked" : "" } onChange={ onSelectAllCheckmarksChange } />
      </div>
      { mobileParticipants }
    </div>
  );
}

/**
 * @function MobileACHParticipantsTableRow
 * @returns {React.Component}
 * @exported false
 * @description The repeated table row for the MobileACHParticipantsTable.
 * @param {STRING} name - Sets the name of the ACH Participant.
 * @param {STRING} accountName - Sets the name of the account for the ACH Participant.
 * @param {STRING} accountNumber - Sets the last four of the account for the ACH Participant.
 * @param {STRING} routingNumber - Sets the routing number of the ACH Participant.
 * @param {STRING} accountStatus - Sets the status of the ACH Participant.
 * @param {STRING} dateCreated - Sets the date when the ACH Participant was created.
 * @param {STRING} timeCreated - Sets the time when the ACH Participant was created.
 */
function MobileACHParticipantsTableRow(props) {
  const { data, ui, onParticipantChecked } = useStateManager();
  const participant = props.participant ?? {};

  return(
    <div className="mobile-ach-participants-table-row flex-container flex-horizontal align-center">
      <div className="set-width checkbox-container">
        <UICheckbox value={ participant.isChecked } onChange={ onParticipantChecked(participant.id) } />
      </div>
      <div className="flex-width content-container">
        <DisabledPrompt>
          <Link className="participant-item">{ participant.nickname }</Link>
        </DisabledPrompt>
        <div className="flex-container flex-horizontal participant-item">
          <b className="set-width">Account</b>
          <p className="flex-width text-right">{ `${participant.accountType } ${participant.number}` }</p>
        </div>
        <div className="flex-container flex-horizontal participant-item">
          <b className="set-width">Routing Number</b>
          <p className="flex-width text-right">{ participant.routing }</p>
        </div>
        <div className="flex-container flex-horizontal participant-item">
          <b className="set-width">Status</b>
          <p className="flex-width text-right">{ participant.status }</p>
        </div>
        <div className="flex-container flex-horizontal participant-item">
          <b className="set-width">Created</b>
          <p className="flex-width text-right">{ `${ participant.createdDate.format("m/d/Y") } ${ participant.createdDate.format('h:i') } AM` }</p>
        </div>
      </div>
      <div className="set-width icon-container">
        <DisabledPrompt>
          <SVGAsset id="EditIcon" className="actionable-icon clickable" />
        </DisabledPrompt>
        <DisabledPrompt>
          <SVGAsset id="TrashcanXIcon" className="actionable-icon clickable" />
        </DisabledPrompt>
      </div>
    </div>
  );
}